import { Box, Button } from '@mui/material';
import { Moment } from 'moment-timezone';

import { formatTime, formatTimeRange } from '../../utils/datetimes/formatting';
import { AxleTime } from '../../utils/datetimes/time';

export const TimeButtonMoment = ({
    startTime,
    endTime,
    timezone,
    onClick,
    selected = false,
    minWidth,
}: {
    selected?: boolean;
    startTime: Moment;
    endTime: Moment | null;
    timezone: string;
    onClick: () => void;
    minWidth?: number;
}) => {
    return (
        <Button
            variant={selected ? 'contained' : 'outlined'}
            style={{
                minWidth,
                borderRadius: '10px',
                fontSize: '0.9rem',
            }}
            onClick={onClick} // Pass the onClick function to the Button component
        >
            <Box flex={1} flexDirection='column'>
                {endTime === null
                    ? formatTime(startTime, timezone)
                    : formatTimeRange(startTime, endTime, timezone)}
            </Box>
        </Button>
    );
};

export const TimeButtonTime = ({
    startTime,
    endTime,
    onClick,
    selected = false,
}: {
    selected?: boolean;
    startTime: AxleTime;
    endTime: AxleTime;
    onClick: () => void;
}) => {
    return (
        <Button
            variant={selected ? 'contained' : 'outlined'}
            style={{
                width: 220,
                height: 40,
                borderRadius: '10px',
                fontSize: '0.9rem',
            }}
            onClick={onClick} // Pass the onClick function to the Button component
        >
            <Box flex={1} flexDirection='column'>
                {`${startTime.toDisplayString()} – ${endTime.toDisplayString()}`}
            </Box>
        </Button>
    );
};
